import angular from 'angular';
import onboardingLinkNavigation from './onboardingLinkNavigation';
import './style.scss';

export default angular
  .module('components.onboardingLinkNavigation', [])
  .component('onboardingLinkNavigation', onboardingLinkNavigation).name;
